import { render, staticRenderFns } from "./UserScans.vue?vue&type=template&id=425fad32"
import script from "./UserScans.vue?vue&type=script&lang=js"
export * from "./UserScans.vue?vue&type=script&lang=js"
import style0 from "./UserScans.vue?vue&type=style&index=0&id=425fad32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports